import { SpaceNotificationPreference } from '@tribeplatform/gql-client/types'
import { RadioGroup } from '@tribeplatform/react-ui-kit/RadioGroup'

import {
  MemberNotificationSettingOptions,
  SpaceDefaultNotificationSettingOptions,
} from './utils'

export const NotificationPreferences = ({
  value,
  onChange,
  showDescriptions = true,
  context = 'memberSettings',
}: {
  value: SpaceNotificationPreference
  onChange: (newValue: SpaceNotificationPreference) => void
  showDescriptions?: boolean
  context?: 'memberSettings' | 'defaultSettings'
}) => {
  const options =
    context === 'memberSettings'
      ? MemberNotificationSettingOptions
      : SpaceDefaultNotificationSettingOptions

  return (
    <RadioGroup value={value} onChange={onChange}>
      <RadioGroup.Items>
        {options.map(option => (
          <RadioGroup.Item key={option.value} value={option.value}>
            <span className="block">{option.label}</span>
            {showDescriptions && (
              <span className="text-basicSurface-500 block text-sm">
                {option.description}
              </span>
            )}
          </RadioGroup.Item>
        ))}
      </RadioGroup.Items>
    </RadioGroup>
  )
}
